import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('endUser')

export const FETCH_END_USER = makeConstant('FETCH_END_USER')
export const FETCH_END_USER_PENDING = makeConstant('FETCH_END_USER_PENDING')
export const FETCH_END_USER_FAILED = makeConstant('FETCH_END_USER_FAILED')
export const FETCH_END_USER_CANCELLED = makeConstant('FETCH_END_USER_CANCELLED')
export const RECEIVE_END_USER = makeConstant('RECEIVE_END_USER')

export const UPDATE_END_USER = makeConstant('UPDATE_END_USER')
export const UPDATE_END_USER_PENDING = makeConstant('UPDATE_END_USER_PENDING')
export const UPDATE_END_USER_FAILED = makeConstant('UPDATE_END_USER_FAILED')

export const FETCH_END_USER_LIST = makeConstant('FETCH_END_USER_LIST')
export const FETCH_END_USER_LIST_PENDING = makeConstant('FETCH_END_USER_LIST_PENDING')
export const FETCH_END_USER_LIST_FAILED = makeConstant('FETCH_END_USER_LIST_FAILED')
export const FETCH_END_USER_LIST_CANCELLED = makeConstant('FETCH_END_USER_LIST_CANCELLED')
export const FETCH_END_USER_LIST_SUCCESS = makeConstant('FETCH_END_USER_LIST_SUCCESS')

export const JOIN_END_USER_CHANNEL = makeConstant('JOIN_END_USER_CHANNEL')
export const CLOSE_END_USER_CHANNEL = makeConstant('CLOSE_END_USER_CHANNEL')

export const FETCH_FOLLOWING = makeConstant('FETCH_FOLLOWING')
export const FETCH_FOLLOWING_PENDING = makeConstant('FETCH_FOLLOWING_PENDING')
export const FETCH_FOLLOWING_FAILED = makeConstant('FETCH_FOLLOWING_FAILED')
export const FETCH_FOLLOWING_SUCCESS = makeConstant('FETCH_FOLLOWING_SUCCESS')
export const FETCH_FOLLOWING_CANCELLED = makeConstant('FETCH_FOLLOWING_CANCELLED')

export const UPDATE_FOLLOWING = makeConstant('UPDATE_FOLLOWING')
export const UPDATE_FOLLOWING_PENDING = makeConstant('UPDATE_FOLLOWING_PENDING')
export const UPDATE_FOLLOWING_FAILED = makeConstant('UPDATE_FOLLOWING_FAILED')
export const UPDATE_FOLLOWING_SUCCESS = makeConstant('UPDATE_FOLLOWING_SUCCESS')

export const UPDATE_CQL = makeConstant('UPDATE_CQL')
export const UPDATE_CQL_PENDING = makeConstant('UPDATE_CQL_PENDING')
export const UPDATE_CQL_FAILED = makeConstant('UPDATE_CQL_FAILED')
export const UPDATE_CQL_SUCCESS = makeConstant('UPDATE_CQL_SUCCESS')

export const CHECK_UNSUBSCRIBED = makeConstant('CHECK_UNSUBSCRIBED')
export const CHECK_UNSUBSCRIBED_PENDING = makeConstant('CHECK_UNSUBSCRIBED_PENDING')
export const CHECK_UNSUBSCRIBED_FAILED = makeConstant('CHECK_UNSUBSCRIBED_FAILED')
export const CHECK_UNSUBSCRIBED_SUCCESS = makeConstant('CHECK_UNSUBSCRIBED_SUCCESS')

export const UNSUBSCRIBE = makeConstant('UNSUBSCRIBE')
export const UNSUBSCRIBE_BY_ID = makeConstant('UNSUBSCRIBE_BY_ID')
export const UNSUBSCRIBE_BY_ENCODED_EMAIL = makeConstant('UNSUBSCRIBE_BY_ENCODED_EMAIL')
export const UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID = makeConstant('UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID')
export const UNSUBSCRIBE_PENDING = makeConstant('UNSUBSCRIBE_PENDING')
export const UNSUBSCRIBE_FAILED = makeConstant('UNSUBSCRIBE_FAILED')
export const UNSUBSCRIBE_SUCCESS = makeConstant('UNSUBSCRIBE_SUCCESS')

export const RESUBSCRIBE = makeConstant('RESUBSCRIBE')
export const RESUBSCRIBE_BY_EMAIL_AND_ORG_ID = makeConstant('RESUBSCRIBE_BY_EMAIL_AND_ORG_ID')
export const RESUBSCRIBE_PENDING = makeConstant('RESUBSCRIBE_PENDING')
export const RESUBSCRIBE_FAILED = makeConstant('RESUBSCRIBE_FAILED')
export const RESUBSCRIBE_SUCCESS = makeConstant('RESUBSCRIBE_SUCCESS')

export const FETCH_UNSUBSCRIBED_COUNT = makeConstant('FETCH_UNSUBSCRIBED_COUNT')
export const FETCH_UNSUBSCRIBED_COUNT_PENDING = makeConstant('FETCH_UNSUBSCRIBED_COUNT_PENDING')
export const FETCH_UNSUBSCRIBED_COUNT_FAILED = makeConstant('FETCH_UNSUBSCRIBED_COUNT_FAILED')
export const FETCH_UNSUBSCRIBED_COUNT_SUCCESS = makeConstant('FETCH_UNSUBSCRIBED_COUNT_SUCCESS')

export const CREATE_PROPERTY_DEFINITION = makeConstant('CREATE_PROPERTY_DEFINITION')
export const CREATE_PROPERTY_DEFINITION_PENDING = makeConstant('CREATE_PROPERTY_DEFINITION_PENDING')
export const CREATE_PROPERTY_DEFINITION_FAILED = makeConstant('CREATE_PROPERTY_DEFINITION_FAILED')
export const CREATE_PROPERTY_DEFINITION_SUCCESS = makeConstant('CREATE_PROPERTY_DEFINITION_SUCCESS')
export const CREATE_PROPERTY_DEFINITION_CANCELLED = makeConstant('CREATE_PROPERTY_DEFINITION_CANCELLED')

export const REQUEST_CONTACT_DATA = makeConstant('REQUEST_CONTACT_DATA')
export const REQUEST_CONTACT_DATA_PENDING = makeConstant('REQUEST_CONTACT_DATA_PENDING')
export const REQUEST_CONTACT_DATA_SUCCESS = makeConstant('REQUEST_CONTACT_DATA_SUCCESS')
export const REQUEST_CONTACT_DATA_FAILED = makeConstant('REQUEST_CONTACT_DATA_FAILED')

export const REQUEST_DELETE_CONTACT_DATA = makeConstant('REQUEST_DELETE_CONTACT_DATA')
export const REQUEST_DELETE_CONTACT_DATA_PENDING = makeConstant('REQUEST_DELETE_CONTACT_DATA_PENDING')
export const REQUEST_DELETE_CONTACT_DATA_SUCCESS = makeConstant('REQUEST_DELETE_CONTACT_DATA_SUCCESS')
export const REQUEST_DELETE_CONTACT_DATA_FAILED = makeConstant('REQUEST_DELETE_CONTACT_DATA_FAILED')

export const REQUEST_UNSUB_DELETE_DATA = makeConstant('REQUEST_UNSUB_DELETE_DATA')
export const REQUEST_UNSUB_DELETE_DATA_PENDING = makeConstant('REQUEST_UNSUB_DELETE_DATA_PENDING')
export const REQUEST_UNSUB_DELETE_DATA_FAILED = makeConstant('REQUEST_UNSUB_DELETE_DATA_FAILED')
export const REQUEST_UNSUB_DELETE_DATA_SUCCESS = makeConstant('REQUEST_UNSUB_DELETE_DATA_SUCCESS')
export const REQUEST_UNSUB_DELETE_DATA_CANCELLED = makeConstant('REQUEST_UNSUB_DELETE_DATA_CANCELLED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/constants.js